import React from 'react';
import {DeviceType} from '../../../../../incase-domain/common/DeviceType.enum';
import {IElementQuestionnaire} from '../../../../../incase-domain/elements/base/questionElementBase';

interface QuestionTitleProps {
    element: IElementQuestionnaire;
    device?: DeviceType;
    hostStyled?: boolean;
}

export default function QuestionTitle(props: QuestionTitleProps): JSX.Element {
    const {element, device, hostStyled = false} = props;

    return (
        <div
            className={`c-questionTitle ${device ? 'c-questionTitle--mobile' : ''}`}
            style={hostStyled ? undefined : getElementStyle(element, device)}
        >
            {element.question}
        </div>
    );
}

function getElementStyle(element: IElementQuestionnaire, device?: DeviceType): React.CSSProperties {
    if (device === DeviceType.MOBILE) {
        return {
            textAlign: element.questionTextAlign,
            fontFamily: element.fontFamily?.name,
        } as React.CSSProperties;
    }

    return {
        textAlign: element.questionTextAlign,
        fontSize: `${element.questionFontSize || 'initial'}em`,
        fontFamily: element.fontFamily?.name,
    } as React.CSSProperties;
}
